import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IntersectionObserverModule } from 'src/core-lib/intersection-observer/intersection-observer.module';
import { LazyLoadModule } from 'src/core-lib/lazy-load/lazy-load.module';
import { OverlayComponent } from './overlay.component';
@NgModule({
    declarations: [
        OverlayComponent,
    ],
    imports: [
        CommonModule,
        IntersectionObserverModule,
        LazyLoadModule,
    ],
    exports: [
        OverlayComponent
    ],
    providers: []
})
export class OverlayModule { }
